module.exports = __webpack_public_path__ + "img/logikon.36962814.png";